import React from "react";
import { Box, Typography, IconButton ,CircularProgress} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import search from "../../assets/Dashboard/search.svg";
import notification from "../../assets/Dashboard/notification.svg";
import person from "../../assets/Dashboard/person.svg";
import CustomText, { textStyles } from "../CustomText";
import more from "../../assets/Dashboard/more.svg";
import activenotification from "../../assets/activenotification.svg";
import notification1 from "../../assets/notification1.svg";
import notification2 from "../../assets/notification2.svg";
import notification3 from "../../assets/notification3.svg";
import activemore from "../../assets/activemore.svg";
import profileicon from "../../assets/profileicon.svg";
import changepassword from "../../assets/changepassword.svg";
import logouticon from "../../assets/logouticon.svg";
import mark from "../../assets/mark.svg";
import arrowdown from "../../assets/arrowdown.svg";
import ProfileDrawer from "../../pages/AdminPages/Dashboard/ProfileDrawer";
import LanguageSwitcher from "../LanguageSwitcher";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../Redux/Slices/AuthSlice";
import ChangePassword from "../../pages/AdminPages/Dashboard/ChangePassword";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { showUnderDevelopment } from "../../components/Alert"
import CustomButton from "../../components/CustomButton";
import { BASE_URL } from "../../components/BaseUrl";
import { decryptToken } from "../../Utlis/Encryption";
import LogoutModal from "../LogoutModal";
import { useTheme } from "../../contexts/ThemeContext";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import expence from "../../assets/Sidebar/expence.svg";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import {toast} from "react-hot-toast";
import dummy from "../../assets/dummy.png"
import { getLocalizedNotification } from "../../utils/notificationLocale";
import { apiFetch } from "../../utils/apiService";
import projectlogo from "../../assets/projectlogo.png";
const DashboardHeader = ({
  isMobile,
  toggleSidebar,
  toggleHeaderMenu,
  showHeaderMenu,
  profile,
  minimal = false,
  upgradeToken = null
}) => {
  const { t, i18n } = useTranslation();
  const { primaryColor, secondaryColor, primaryTextColor, secondaryTextColor, clearThemeCache } = useTheme();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showProfileDrawer, setShowProfileDrawer] = useState(false);
  const [upgradeProfile, setUpgradeProfile] = useState(null);
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  const dispatch = useDispatch();
  const [showGlobalSearch, setShowGlobalSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);
  // console.log("email user", user);
  const handleUpgrade = () => {
    navigate("/get-plans")
  }
  // const [profile, setProfile] = useState(null);

  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const headerToken = upgradeToken || decryptedToken;

  useEffect(() => {
    if (!minimal || !upgradeToken) return;
    const fetchUpgradeProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}/company-admins/profile`, {
          headers: { Authorization: `Bearer ${upgradeToken}` },
        });
        const result = await response.json();
        if (response.ok && !result.error) setUpgradeProfile(result.data);
      } catch (error) {
        console.error("Upgrade profile fetch error:", error);
      }
    };
    fetchUpgradeProfile();
  }, [minimal, upgradeToken]);
  useEffect(() => {
    console.log("Updated Profile in Header:", profile);
  }, [profile]);

  


  const getProfileImageSrc = (raw) => {
    if (!raw) return person;
    if (raw.startsWith("data:")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    const prefix = raw.startsWith("/") ? "" : "/";
    return `${BASE_URL}${prefix}${raw}`;
  };
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);


const [notifications, setNotifications] = useState([]);
const [loading, setLoading] = useState(true);
const [marking, setMarking] = useState(false);

const fetchNotifications = async () => {
  setLoading(true);
  try {
    const response = await fetch(`${BASE_URL}/notifications/company-admin?limit=5&offset=0`, {
      method: "GET",
      headers: { Authorization: `Bearer ${decryptedToken}` },
    });
    const data = await response.json();
    if (data.success) setNotifications(data.data.notifications);
  } catch (error) {
    console.error("Error fetching notifications:", error);
  } finally {
    setLoading(false);
  }
};

const markAllAsRead = async () => {
  try {
    const data = await apiFetch(
      `${BASE_URL}/notifications/company-admin/mark-all-read`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    if (data.ok && !data.error) {
      toast.success(data.message);
    } else {
      toast.error(data.message || t("error.markReadFailed"));
    }

  } catch (error) {
    console.error("Error marking all as read:", error);
    toast.error(t("error.markReadFailed"));
  }
};;


const fetchUnreadCount = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}/notifications/unread-count`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    const data = await response.json();
   console.log("Unread count response:", data);
    if (!data.error) {
      setUnreadCount(data.data.unread_count || 0);
    }
  } catch (error) {
    console.error("Failed to fetch unread count", error);
  }
};


useEffect(() => {
  if (minimal || !headerToken) return;
  fetchUnreadCount();
}, [minimal, headerToken]);

const moreMenuRef = useRef(null);
const moreTriggerRef = useRef(null);
const moreTriggerMobileRef = useRef(null);

useEffect(() => {
  if (!showMoreOptions) return;

  const handleClickOutside = (event) => {
    const isOutside = (ref) => !ref.current || !ref.current.contains(event.target);
    if (isOutside(moreMenuRef) && isOutside(moreTriggerRef) && isOutside(moreTriggerMobileRef)) {
      setShowMoreOptions(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [showMoreOptions]);

  if (minimal) {
    const minimalUser = upgradeProfile?.user || {};
    const minimalName = minimalUser.full_name ||
      `${minimalUser.first_name || ""} ${minimalUser.last_name || ""}`.trim() ||
      "Company Admin";

    return (
      <Box
        sx={{
          height: 70,
          px: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1.5, sm: 3 } }}>
          <Box
            component="img"
            src={projectlogo}
            alt="Biometric PRO"
            sx={{ width: { xs: 145, sm: 170 }, height: 54, objectFit: "contain" }}
          />
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 700, color: "#172B4D" }}>
            {t("dashboard.title") || "Company Admins"}
          </CustomText>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 2 } }}>
          <LanguageSwitcher variant="dashboard" />
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <CustomText 
                sx={{
                    ...textStyles.body5,
                    color: "#363333",
                    fontSize: "15px",
                    fontWeight: 500,
                    pt: 1.2,
                    textAlign: "left",
                    letterSpacing: "0px !important",
                  }}>
              {minimalName}
            </CustomText>
            <CustomText 
                sx={{
                    ...textStyles.body5,
                    color: "#939393",
                    fontSize: "13px",
                    fontWeight: 400,
                    pt: 0,
                    textAlign: "left",
                    letterSpacing: "0px !important",
                  }}>
              {minimalUser.email || ""}
            </CustomText>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        // height:isMobile?70: 70,
        height: 70,
        px: 2,
        display: "flex",
        py: isMobile ? 3 : 2,
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #E0E0E0",
        backgroundColor: "#FFFFFF",
      }}
    >
      {isMobile ? (
        <>
          {/* Left: Sidebar Toggle */}
          <IconButton onClick={toggleSidebar}>
            <MenuIcon />
          </IconButton>

          {/* Center: Title */}
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 700,
              color: "#172B4D",
            }}
          >
            {t("dashboard.title") || "Company Admins"}
          </CustomText>

          {/* Right: More/Menu Toggle */}
          <IconButton onClick={toggleHeaderMenu}>
            <MoreVertIcon />
          </IconButton>
        </>
      ) : (
        <>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 700,
              color: "#172B4D",
            }}
          >
            {t("dashboard.title") || "Company Admins"}
          </CustomText>
          {/* Right Side Icons and Profile for Desktop */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>

            {/* <CustomButton label='Upgrade' size='small' sx={{height:"18px",py:0.5,px:2, height:"35px!important " }} onClick={handleUpgrade}/> */}
            {/* Language Switcher */}
            <LanguageSwitcher variant="dashboard" />

            {/* <Box
              component="img"
              src={search}
              alt="search"
              sx={{ width: 20, height: 20 }}
              
            /> */}

            {/* <Box
              component="img"
              // onClick={() => setShowNotifications((prev) => !prev)}
onClick={() => {
  navigate('/notifications');  // Navigate to the notifications route
}}
              // onClick={showUnderDevelopment}
              src={showNotifications ? activenotification : notification}
              alt="notification"
              sx={{ width: 24, height: 24, cursor: "pointer" }}
            /> */}


<Box
  sx={{ position: "relative", cursor: "pointer" }}
  onClick={() => navigate("/notifications")}
>
  <Box
    component="img"
    src={showNotifications ? activenotification : notification}
    alt="notification"
    sx={{ width: 24, height: 24 }}
  />

  {unreadCount > 0 && (
    <Box
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        minWidth: 18,
        height: 18,
        backgroundColor: "#E53935",
        color: "#fff",
        borderRadius: "50%",
        fontSize: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: unreadCount > 9 ? 0.8 : 0,
      }}
    >
      {unreadCount > 99 ? "99+" : unreadCount}
    </Box>
  )}
</Box>


            <Box ref={moreTriggerRef} sx={{ display: "flex", alignItems: "center", gap: 1 }}
               onClick={() => setShowMoreOptions((prev) => !prev)}>
              <Box
                component="img"
                crossOrigin="anonymous"
                src={profile?.user?.profile_picture ? profile.user.profile_picture : "default-image-url"}
                alt="user"
  onError={(e) => (e.currentTarget.src = dummy)}
                sx={{ width: 32, height: 32, borderRadius: "50%" }}
              />
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <CustomText
                  sx={{
                    ...textStyles.body5,
                    color: "#363333",
                    fontSize: "15px",
                    fontWeight: 500,
                    pt: 1.2,
                    textAlign: "left",
                    letterSpacing: "0px !important",
                  }}
                >

                
                  {profile?.user?.full_name || `${profile?.user?.first_name || ""} ${profile?.user?.last_name || ""}` || "John Doe"}
                </CustomText>
                <CustomText
                  sx={{
                    ...textStyles.body5,
                    color: "#939393",
                    fontSize: "13px",
                    fontWeight: 400,
                    pt: 0,
                    textAlign: "left",
                    letterSpacing: "0px !important",
                  }}
                >
                  {/* john.doe@gmail.com
                   */}
                  {/* {user?.email || "john.doe@gmail.com"} */}
                  {/* {profile?.email || "john.doe@gmail.com"} */}
                  {profile?.user?.email || "john.doe@gmail.com"}

                </CustomText>
              </Box>
              {/* <Box component="img" src={more} alt="more" sx={{ width: 16, height: 16, ml: 1 }} /> */}
              <Box
                component="img"
                src={showMoreOptions ? activemore : more}
                alt="more"
    onError={(e) => (e.currentTarget.src = dummy)}
                sx={{ width: 18, height: 18, ml: 0, cursor: "pointer" }}
              />
            </Box>
          </Box>
        </>
      )}
      {showMoreOptions && (
        <Box
          ref={moreMenuRef}
          sx={{
            position: "absolute",
            top: isMobile ? 170 : 70,
            right: 25,
            width: 190,
            backgroundColor: "#fff",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: "6px",
            overflow: "hidden",
            zIndex: 2000,
          }}
        >
          {[
            {
              label: t("dashboard.profile"),
              icon: profileicon,
              action: () => {
                setShowMoreOptions(false); // close dropdown
                setShowProfileDrawer(true);
                if (isMobile) {
                  toggleHeaderMenu(); // closes the mobile menu
                } // open drawer
              },
            },
            {
              label: t("dashboard.change_password"),
              icon: changepassword,
              action: () => {
                setShowMoreOptions(false);
                if (isMobile) toggleHeaderMenu();
                setOpen(true);
              },
            },
            {
              label: t("subscriptionAndPlans"),
              icon: expence,
              action: () => {
                setShowMoreOptions(false);
                if (isMobile) toggleHeaderMenu();
                navigate("/subscription-plans"); // 👈 route for subscription page
              },
            },

            {
              label: t("dashboard.logout"),
              icon: logouticon,
              action: () => {
                setShowMoreOptions(false);
                setShowLogoutModal(true); // 👈 open modal instead of direct logout
              },
            }
          ].map((item, i) => (
            <Box
              key={i}
              onClick={item.action}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 1.2,
                borderBottom: i < 2 ? "1px solid #eee" : "none",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: secondaryColor,
                  "& .MuiTypography-root": {
                    color: 'white',
                  },
                  "& img": {
                    filter: 'brightness(0) invert(1)',
                  },
                },
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={item.label}
                sx={{ width: 18, height: 18 }}
              />
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#222529",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
      <ChangePassword open={open} onClose={() => setOpen(false)} />
      <ProfileDrawer
        open={showProfileDrawer}
        onClose={() => setShowProfileDrawer(false)}
      />

      {showNotifications && (
  <Box
    sx={{
      position: "absolute",
      top: isMobile ? 170 : 70,
      right: isMobile ? 0 : 200,
      width: isMobile ? 320 : 420,
      backgroundColor: "#fff",
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
      borderRadius: "0px",
      overflow: "hidden",
      zIndex: 2000,
      display: "flex",
      flexDirection: "column",
      maxHeight: 400,
    }}
  >
    {/* Header */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        py: 1.5,
        borderBottom: "1px solid #eee",
      }}
    >
      <Typography sx={{ fontSize: 16, fontWeight: 600, color: "#222529", fontFamily: "Poppins, sans-serif" }}>
        {t("notifications")}
      </Typography>
      <IconButton
        onClick={markAllAsRead}
        disabled={marking}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          backgroundColor: "#006EC2",
          color: "white",
          px: 1.5,
          py: 0.5,
          borderRadius: "6px",
          "&:hover": { backgroundColor: "#005bb5" },
        }}
      >
        {marking ? (
          <CircularProgress size={16} sx={{ color: "white" }} />
        ) : (
          <>
            <MarkEmailReadOutlinedIcon sx={{ fontSize: 16 }} />
            <Typography sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}>
              {t("markAsRead")}
            </Typography>
          </>
        )}
      </IconButton>
    </Box>

    {/* Notifications List */}
    <Box
      sx={{
        overflowY: "auto",
        maxHeight: 300,
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 250 }}>
          <CircularProgress size={32} />
        </Box>
      ) : notifications.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 3 }}>
          <Typography sx={{ fontSize: 14, color: "#777",
            fontFamily: 'Poppins, sans-serif',
           }}>{t("empty.no_user")}</Typography>
        </Box>
      ) : (
        notifications.map((n, i) => {
          const { title, message } = getLocalizedNotification(n, i18n.language);
          return (
          <Box
            key={i}
            sx={{
              px: 2,
              py: 1.2,
              borderBottom: "1px solid #eee",
              backgroundColor: !n.is_read ? "#EAF4FF" : "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#222", fontFamily: "Poppins, sans-serif" }}>
                {title}
              </Typography>
              <Typography sx={{ fontSize: 13, color: "#555", fontFamily: "Poppins, sans-serif" }}>
                {message}
              </Typography>

            </Box>
          </Box>
          );
        })
      )}
    </Box>

  
  </Box>
)}

      {isMobile && showHeaderMenu && (
        <Box
          sx={{
            position: "absolute",
            top: "70px",
            right: 0,
            width: "100%",
            backgroundColor: "#FFFFFF",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            zIndex: 1300,
            px: 2,
            py: 1.3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
        
            <LanguageSwitcher variant="dashboard" />

        <Box
  sx={{ position: "relative", cursor: "pointer" }}
  onClick={() => navigate("/notifications")}
>
  <Box
    component="img"
    src={showNotifications ? activenotification : notification}
    alt="notification"
    sx={{ width: 24, height: 24 }}
  />

  {unreadCount > 0 && (
    <Box
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        minWidth: 18,
        height: 18,
        backgroundColor: "#E53935",
        color: "#fff",
        borderRadius: "50%",
        fontSize: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: unreadCount > 9 ? 0.8 : 0,
      }}
    >
      {unreadCount > 99 ? "99+" : unreadCount}
    </Box>
  )}
</Box>
          </Box>
          <Box ref={moreTriggerMobileRef} sx={{ display: "flex", alignItems: "center", gap: 1 }}
              onClick={() => setShowMoreOptions((prev) => !prev)}>
            <Box
              component="img"
              crossOrigin="anonymous"
              //  src={profile?.profile_picture || profile?.logo || person}
              src={profile?.user?.profile_picture ? profile.user.profile_picture : "default-image-url"}

              alt="user"
              sx={{ width: 32, height: 32, borderRadius: "50%" }}
            />
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <CustomText
                sx={{
                  ...textStyles.body5,
                  color: "#363333",
                  fontSize: "15px",
                  fontWeight: 500,
                  pt: 1.2,
                  textAlign: "left",
                  letterSpacing: "0px !important",
                }}
              >
                {/* {profile?.full_name || `${profile?.first_name || ""} ${profile?.last_name || ""}` || "John Doe"} */}
                {profile?.user?.full_name || `${profile?.user?.first_name || ""} ${profile?.user?.last_name || ""}` || "John Doe"}

              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.body5,
                  color: "#939393",
                  fontSize: "13px",
                  fontWeight: 400,
                  pt: 0,
                  textAlign: "left",
                  letterSpacing: "0px !important",
                }}
              >
                {/* {profile?.email || "john.doe@gmail.com"}      */}
                {/* {profile?.email || "john.doe@gmail.com"} */}
                {profile?.user?.email || "john.doe@gmail.com"}


              </CustomText>
            </Box>
            <Box
              component="img"
              src={showMoreOptions ? activemore : more}
              alt="more"
          
              sx={{ width: 16, height: 16, ml: 1, cursor: "pointer" }}
            />
          </Box>
        </Box>
      )}
      {showGlobalSearch && (
        <Box
          sx={{
            position: "absolute",
            top: 70,
            right: 80,
            width: 400,
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: "0px 6px 24px rgba(0, 0, 0, 0.12)",
            px: 2,
            py: 1.5,
            zIndex: 3000,
          }}
        >
          <Box
            sx={{
              position: "relative",
              mb: 2,
              borderBottom: "1px solid rgba(170, 162, 162, 0.42)",
            }}
          >
            <input
              type="text"
              placeholder="Search globally..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                // 👈 this updates table filtering
              }}
              style={{
                width: "100%",
                padding: "10px 36px 10px 12px",
                fontSize: "14px",
                border: "none",
                outline: "none",
                borderRadius: "8px",

                fontFamily: "Poppins, sans-serif",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                right: 10,
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                fontSize: 18,
                color: "#6B7280",
                fontWeight: 500,
              }}
              onClick={() => setShowGlobalSearch(false)}
            >
              ×
            </Box>
          </Box>

          <CustomText
            sx={{
              ...textStyles.body5,
              pb: 0.8,
              color: "#5E5C5C",
              fontSize: "12px",
              fontWeight: 400,
              textAlign: "left",
              letterSpacing: "0px !important",
            }}
          >
            Previous 7 Days
          </CustomText>
          <CustomText
            sx={{
              ...textStyles.body5,
              pb: 0.8,
              color: "#181818",
              fontSize: "14px",
              fontWeight: 400,
              textAlign: "left",
              letterSpacing: "0px !important",
            }}
          >
            Registered Companies{" "}
          </CustomText>
          <CustomText
            sx={{
              ...textStyles.body5,
              pb: 0.8,
              color: "#181818",
              fontSize: "14px",
              fontWeight: 400,
              textAlign: "left",
              letterSpacing: "0px !important",
            }}
          >
            All inactive account
          </CustomText>

          <CustomText
            sx={{
              ...textStyles.body5,
              pb: 0.8,
              color: "#5E5C5C",
              fontSize: "12px",
              fontWeight: 400,
              textAlign: "left",
              letterSpacing: "0px !important",
            }}
          >
            Previous 30 Days
          </CustomText>
          <CustomText
            sx={{
              ...textStyles.body5,
              pb: 0.8,
              color: "#181818",
              fontSize: "14px",
              fontWeight: 400,
              textAlign: "left",
              letterSpacing: "0px !important",
            }}
          >
            All account executives
          </CustomText>
          <CustomText
            sx={{
              ...textStyles.body5,
              pb: 0.8,
              color: "#181818",
              fontSize: "14px",
              fontWeight: 400,
              textAlign: "left",
              letterSpacing: "0px !important",
            }}
          >
            Most paid subscriptions
          </CustomText>
          <CustomText
            sx={{
              ...textStyles.body5,
              pb: 0.8,
              color: "#181818",
              fontSize: "14px",
              fontWeight: 400,
              textAlign: "left",
              letterSpacing: "0px !important",
            }}
          >
            Payouts
          </CustomText>
        </Box>
      )}
      <LogoutModal
        open={showLogoutModal}
        loading={logoutLoading}
        onClose={() => setShowLogoutModal(false)}
         onConfirm={async () => {
           try {
             setLogoutLoading(true);
             // Clear theme cache before logout
             clearThemeCache();
             // dispatch logout
             await dispatch(logout());
             navigate("/"); // redirect after logout
           } finally {
             setLogoutLoading(false);
             setShowLogoutModal(false);
           }
         }}
      />
    </Box>
  );
};

export default DashboardHeader;
